module.exports = __webpack_public_path__ + "img/screen_iphone1.87230bd5.png";